/* 
  通过患者年龄计算患者生日函数封装
  create by 李智惠 2021-08-23
*/
// 月、日不足10补0
let zeroAdd = function(num) {
  num >= 10 ? num : num = '0' + num;
  return num; 
}

// 获取某年某月有多少天
const getDate = (year, month) => new Date(year, month, 0).getDate()

function computeBirthday(year = 0, month = 0) {
  /*
    * 之前的逻辑，在计算闰年的时候，生日的天数计算有误
    let birthday = null;
    const nowTimeStamp = new Date().getTime();
    let timeStamp = year * 365 * 24 * 60 * 60 * 1000 + month * 30 * 24 * 60 * 60 * 1000
    + Math.round(year/4) * 24 * 60 * 60 * 1000 + Math.round(month/2) * 24 * 60 * 60 * 1000;
    let diff = nowTimeStamp - timeStamp;
    birthday = new Date(diff);
    return birthday;
  */
 
  const date = new Date()
  let currentYear = date.getFullYear()
  let currentMonth = date.getMonth() + 1
  let currentDay = date.getDate()
  // 计算实际年月日
  let resultYear = currentYear - year
  let resultMonth = currentMonth - month
  let resultDay = currentDay

  // 计算当前月份有多少天
  const resultMonthDay = getDate(resultYear, resultMonth)

  resultYear = resultMonth <= 0 ? resultYear - 1 : resultYear
  resultMonth = resultMonth <= 0 ? 12 + resultMonth : resultMonth
  resultDay = resultMonthDay < resultDay ? resultMonthDay : resultDay

  return `${resultYear}-${zeroAdd(resultMonth)}-${zeroAdd(resultDay)}`
}
export default computeBirthday;